<div class="card">
  <div class="card-header">
    <h1>Empleados de la Empresa</h1>
  </div>

  <div class="card-body">
    <div class="table-responsive">
      <table class="table table-hover table-bordered mb-0">
        <thead class="table-light">
          <tr>
            <th>Nombre</th>
            <th>Apellido</th>
            <th>Puesto</th>
            <th>Bodega</th>
            <th>Area</th>
            <th>Salario Base</th>
            <th>Bonificación Asignada</th>
            <th>Acciones</th>
          </tr>
        </thead>

        <tbody>
          <ng-container *ngFor="let item of pagination.filter">
            <tr>
              <td>{{ item.employee.nombre }}</td>
              <td>{{ item.employee.apellido }}</td>
              <td>{{ item.position?.name }}</td>
              <td>{{ item.warehouse?.name || 'Sin bodega' }}</td>
              <td>{{ item.area?.name }}</td>
              <td>{{ item.contract?.relationAmount | currency: 'Q' }}</td>
              <td>{{ item.contract?.bonusAmount | currency: 'Q' }}</td>

              <td class="text-center">
                <div style="display: flex; justify-content: center; align-items: center; gap: 1rem;">

                  <!-- Ver detalle contrato -->
                  <span
                    class="clickeable text-info"
                    tooltip="Ver detalle de contrato"
                    (click)="item.showContractDetail = !item.showContractDetail">
                    <i
                      class="fa"
                      [ngClass]="item.showContractDetail ? 'fa-eye-slash' : 'fa-eye'">
                    </i>
                  </span>

                  <!-- Actualizar contrato -->
                  <span
                    class="clickeable text-warning"
                    tooltip="Actualizar contrato"
                    [appCheckPermission]="[2046]"
                    [permissionType]="permissionType.UPDATE"
                    (click)="openUpdateContract(item)">
                    <i class="fa fa-file-contract"></i>
                  </span>

                  <!-- Despedir empleado -->
                  <div
                    class="container-superposition"
                    tooltip="Despedir"
                    [appCheckPermission]="[2046]"
                    [permissionType]="permissionType.DELETE">

                    <div
                      class="element-superposition"
                      *ngIf="waitingFor?.id == item.employee.id && !seeEmployeeTermination">

                      <span>¿Está seguro que desea despedir este empleado?</span>

                      <input
                        type="date"
                        class="form-control form-control-sm mt-2 mb-2"
                        [(ngModel)]="terminationDate">

                      <span class="a-container">
                        <span class="a-hover" (click)="resetDeletingDiv()">
                          <i class="fa fa-ban"></i>NO
                        </span>

                        <span class="a-hover text-danger" (click)="confirmDelete(item.employee)">
                          <i class="fa fa-solid fa-user-xmark"></i>SÍ
                        </span>
                      </span>
                    </div>

                    <span
                      class="clickeable text-danger"
                      (click)="deleteEmployee(item.employee)">

                      <i
                        *ngIf="!deleting[item.employee.id]"
                        class="fa fa-solid fa-user-xmark">
                      </i>

                      <span
                        *ngIf="deleting[item.employee.id]"
                        class="spinner-border spinner-border-sm"
                        aria-hidden="true">
                      </span>
                    </span>
                  </div>

                </div>
              </td>
            </tr>

            <tr *ngIf="item.showContractDetail">
              <td colspan="8">
                <div class="card card-tabs mb-0">
                  <div class="card-body">

                    <label class="title-history">
                      Detalle del contrato
                    </label>

                    <div class="row mb-3">
                      <div class="col-md-6">
                        <strong>Fecha de contratación:</strong>
                        {{ item.employee?.registerDate | date:'dd/MM/yyyy' }}
                      </div>

                       <div class="col-md-6">
                        <strong>Fecha de baja:</strong>
                        {{ item.employee?.dischargeDate | date:'dd/MM/yyyy' }}
                      </div>
                    </div>

                    <div class="table-responsive mt-3">
                      <table class="table table-striped table-bordered mb-0">
                        <thead class="table-light">
                          <tr>
                            <th>Tipo</th>
                            <th>Monto base</th>
                            <th>Aguinaldo 8.33%</th>
                            <th>Bono 14 8.33%</th>
                            <th>Vacaciones 4.17%</th>
                            <th>IGSS 4.83%</th>
                            <th>Total estimado</th>
                          </tr>
                        </thead>

                        <tbody>

                          <tr *ngIf="item.contract?.relationAmount > 0">
                            <td>Relación de dependencia</td>

                            <td>
                              {{ item.contract.relationAmount | currency:'Q' }}
                            </td>

                            <td>
                              <span *ngIf="item.contract.raguinaldo">
                                {{ item.contract.relationAmount * 0.0833 | currency:'Q' }}
                              </span>
                              <span *ngIf="!item.contract.raguinaldo">No aplica</span>
                            </td>

                            <td>
                              <span *ngIf="item.contract.rbono">
                                {{ item.contract.relationAmount * 0.0833 | currency:'Q' }}
                              </span>
                              <span *ngIf="!item.contract.bbono">No aplica</span>
                            </td>

                            <td>
                              <span *ngIf="item.contract.rvacaciones">
                                {{ item.contract.relationAmount * 0.0417 | currency:'Q' }}
                              </span>
                              <span *ngIf="!item.contract.rvacaciones">No aplica</span>
                            </td>

                            <td>
                              <span *ngIf="item.contract.riggs">
                                {{ item.contract.relationAmount * 0.0483 | currency:'Q' }}
                              </span>
                              <span *ngIf="!item.contract.riggs">No aplica</span>
                            </td>

                            <td>
                              {{
                                item.contract.relationAmount
                                + (item.contract.raguinaldo ? item.contract.relationAmount * 0.0833 : 0)
                                + (item.contract.rbono ? item.contract.relationAmount * 0.0833 : 0)
                                + (item.contract.rvacaciones ? item.contract.relationAmount * 0.0417 : 0)
                                + (item.contract.riggs ? item.contract.relationAmount * 0.0483 : 0)
                                | currency:'Q'
                              }}
                            </td>
                          </tr>

                          <tr *ngIf="item.contract?.proAmount > 0">
                            <td>Honorarios profesionales</td>

                            <td>
                              {{ item.contract.proAmount | currency:'Q' }}
                            </td>

                            <td>
                              <span *ngIf="item.contract.paguinaldo">
                                {{ item.contract.proAmount * 0.0833 | currency:'Q' }}
                              </span>
                              <span *ngIf="!item.contract.paguinaldo">No aplica</span>
                            </td>

                            <td>
                              <span *ngIf="item.contract.pbono">
                                {{ item.contract.proAmount * 0.0833 | currency:'Q' }}
                              </span>
                              <span *ngIf="!item.contract.pbono">No aplica</span>
                            </td>

                            <td>
                              <span *ngIf="item.contract.pvacaciones">
                                {{ item.contract.proAmount * 0.0417 | currency:'Q' }}
                              </span>
                              <span *ngIf="!item.contract.pvacaciones">No aplica</span>
                            </td>

                            <td>No aplica</td>

                            <td>
                              {{
                                item.contract.proAmount
                                + (item.contract.paguinaldo ? item.contract.proAmount * 0.0833 : 0)
                                + (item.contract.pbono ? item.contract.proAmount * 0.0833 : 0)
                                + (item.contract.pvacaciones ? item.contract.proAmount * 0.0417 : 0)
                                | currency:'Q'
                              }}
                            </td>
                          </tr>

                          <tr *ngIf="item.contract?.bonusAmount > 0">
                            <td>Otras bonificaciones</td>

                            <td>
                              {{ item.contract.bonusAmount | currency:'Q' }}
                            </td>

                            <td>
                              <span *ngIf="item.contract.baguinaldo">
                                {{ item.contract.bonusAmount * 0.0833 | currency:'Q' }}
                              </span>
                              <span *ngIf="!item.contract.baguinaldo">No aplica</span>
                            </td>

                            <td>
                              <span *ngIf="item.contract.bbono">
                                {{ item.contract.bonusAmount * 0.0833 | currency:'Q' }}
                              </span>
                              <span *ngIf="!item.contract.bbono">No aplica</span>
                            </td>

                            <td>
                              <span *ngIf="item.contract.bvacaciones">
                                {{ item.contract.bonusAmount * 0.0417 | currency:'Q' }}
                              </span>
                              <span *ngIf="!item.contract.bvacaciones">No aplica</span>
                            </td>

                            <td>No aplica</td>

                            <td>
                              {{
                                item.contract.bonusAmount
                                + (item.contract.baguinaldo ? item.contract.bonusAmount * 0.0833 : 0)
                                + (item.contract.bbono ? item.contract.bonusAmount * 0.0833 : 0)
                                + (item.contract.bvacaciones ? item.contract.bonusAmount * 0.0417 : 0)
                                | currency:'Q'
                              }}
                            </td>
                          </tr>

                        </tbody>

                        <tfoot>
                          <tr>
                            <td colspan="6" class="text-end">
                              <strong>Total contrato estimado</strong>
                            </td>

                            <td>
                              <strong>
                                {{
                                  (item.contract?.relationAmount || 0)
                                  + (item.contract?.raguinaldo ? item.contract.relationAmount * 0.0833 : 0)
                                  + (item.contract?.rbono ? item.contract.relationAmount * 0.0833 : 0)
                                  + (item.contract?.rvacaciones ? item.contract.relationAmount * 0.0417 : 0)
                                  + (item.contract?.riggs ? item.contract.relationAmount * 0.0483 : 0)

                                  + (item.contract?.proAmount || 0)
                                  + (item.contract?.paguinaldo ? item.contract.proAmount * 0.0833 : 0)
                                  + (item.contract?.pbono ? item.contract.proAmount * 0.0833 : 0)
                                  + (item.contract?.pvacaciones ? item.contract.proAmount * 0.0417 : 0)

                                  + (item.contract?.bonusAmount || 0)
                                  + (item.contract?.baguinaldo ? item.contract.bonusAmount * 0.0833 : 0)
                                  + (item.contract?.bbono ? item.contract.bonusAmount * 0.0833 : 0)
                                  + (item.contract?.bvacaciones ? item.contract.bonusAmount * 0.0417 : 0)
                                  | currency:'Q'
                                }}
                              </strong>
                            </td>
                          </tr>
                        </tfoot>

                      </table>
                    </div>

                  </div>
                </div>
              </td>
            </tr>
          </ng-container>

          <tr *ngIf="pagination.filter.length === 0">
            <td colspan="8" class="text-center text-muted">
              <i class="fa fa-circle-info"></i>
              No se encontraron empleados.
            </td>
          </tr>
        </tbody>
      </table>

      <app-pagination-custom [elements]="pagination"></app-pagination-custom>
    </div>
  </div>
</div>

<div class="card mt-2" *ngIf="updatingContract">
  <div class="card-body">
    <p class="h3">Actualizar Contrato</p>

    <div class="alert alert-info" *ngIf="employeeToUpdateContract">
      Actualizando contrato de:
      <strong>
        {{ employeeToUpdateContract.employee?.nombre }}
        {{ employeeToUpdateContract.employee?.apellido }}
      </strong>
    </div>

    <div class="row">
      <div class="col-sm form-group">
        <label for="contractProfile" class="form-label">
          Perfil de contratación
        </label>

        <div class="input-group">
          <select
            name="contractProfile"
            id="contractProfile"
            [(ngModel)]="selectedProfile"
            class="form-select">
            <option [ngValue]="null">Seleccione un perfil</option>

            <option
              *ngFor="let contract of contractProfiles"
              [value]="contract.id">
              {{ contract.name }}
            </option>
          </select>

          <button
            class="btn btn-info"
            tooltip="Ve el perfil actual"
            [disabled]="!selectedProfile"
            (click)="showActualProfileSalary()">
            <i class="fa fa-eye"></i>
          </button>
        </div>
      </div>

      <div class="col-sm form-group">
        <label for="position" class="form-label">
          Posición
        </label>

        <select
          name="position"
          id="position"
          class="form-select"
          [(ngModel)]="selectedPosition">
          <option [ngValue]="null">Seleccione una posición</option>

          <option
            *ngFor="let position of positions"
            [value]="position.id">
            {{ position.name }}
          </option>
        </select>
      </div>
    </div>
  </div>

  <div class="card-footer mt-1" style="display: flex; justify-content: space-between;">
    <button
      class="btn btn-info"
      [disabled]="updatingContractEmployee"
      (click)="cancelUpdateContract()">
      <i class="fa fa-ban"></i>
      CANCELAR
    </button>

    <button
      class="btn btn-success"
      [disabled]="!selectedPosition || !selectedProfile || updatingContractEmployee"
      (click)="updateContract()">
      <i *ngIf="!updatingContractEmployee" class="fa fa-save"></i>

      <span
        *ngIf="updatingContractEmployee"
        class="spinner-border spinner-border-sm"
        aria-hidden="true">
      </span>

      ACTUALIZAR
    </button>
  </div>
</div>

<app-modal-salary-profile
  *ngIf="newSalary"
  [newSalary]="newSalary"
  [isCreating]="createProfileSalary"
  (close)="closeModalProfileSalary($event)">
</app-modal-salary-profile>